import * as React from 'react'
import { Grid, Paper } from '@mui/material'
import { formatDate } from 'date-fns'
import GridItem from 'src/components/grid-item/GridItem'
import Concentre from './Concentre'
import Consultas from './Consultas'
import Contatos from './Contatos'
import Endereco from './Endereco'
import Identificacao from './Identificacao'
import Ocupacao from './Ocupacao'
import ParticipacaoSocietaria from './ParticipacaoSocietaria'
import { SerasaPersonRow } from 'src/modules/serasa/serasa.pf.types'

export type SerasaPersonProps = {
    person: SerasaPersonRow
}

export default function SerasaPerson({ person }: SerasaPersonProps) {
    return (
        <Paper elevation={3} style={{ padding: 10 }}>
            {person.dataConsulta && (
                <Grid container spacing={1} paddingTop={2} paddingBottom={2} paddingLeft={5} paddingRight={5}>
                    <GridItem label="Data da Consulta" value={formatDate(person.dataConsulta, 'dd/MM/yyyy')} xs={12} />
                </Grid>
            )}

            <Identificacao person={person} />
            <Endereco person={person} />
            <Contatos person={person} />
            <Ocupacao person={person} />
            <ParticipacaoSocietaria participacoes={person.participacao_societaria} />
            <Concentre concentreRows={person.dadosConcentre} />
            <Consultas consulta={person.consultas} />
        </Paper>
    )
}
